import AWS from "aws-sdk"
import jwt_decode from "jwt-decode"
import Cookies from 'js-cookie'

class Auth {
  constructor(cookieDuration = 7) {
    // set our AWS config properties
    AWS.config.update({
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: process.env.VUE_APP_identityPoolId
      }),
      region: process.env.VUE_APP_region
    })

    // set our ENV variables
    this.clientID = process.env.VUE_APP_userPoolWebClientId
    this.cookieDomain = process.env.VUE_APP_cookie_domain || 'cameramatics.com'
    this.cookieName = process.env.VUE_APP_cookie_name || 'CameraMaticsToken'
    this.cookieDuration = cookieDuration

    this.accessToken = false
    this.idToken = false
    this.refreshToken = false
    this.IdentifyProvider =  new AWS.CognitoIdentityServiceProvider()

    this.Read() // we try to read our token 

    // if we have a refresh token in our cookies, we fetch the other tokens
    if(this.refreshToken) {
      this.Refresh()
    }
  }

  /**
   * Sends a refresh token to cognito and returns a set of user tokens.
   * @param {String} refreshToken - the refresh token given by AWS. if this is not provided, the function will try to use the token stored on in the class.
   * @returns a set of tokens (idToken, accessToken, refreshToken)
   */
  Refresh (refreshToken = false) {
    return new Promise (async (res, rej) => {

      // if there is no token in memory, try to read from cookies
      if(!refreshToken) {
        this.Read()
      }
      
      const token = refreshToken ? refreshToken : this.refreshToken

      if(!token) {
        rej(new Error("no refresh token found"))
      }

      // update our token with whatever we use here
      this.refreshToken = token

      this.IdentifyProvider.initiateAuth({
        AuthFlow: 'REFRESH_TOKEN_AUTH',
        ClientId: this.clientID,
        AuthParameters: {
          REFRESH_TOKEN: token
        }
      }, (err, data) => {
        if(err) {
          this.Clear()
          rej(new Error("sign in failed"))
        }
 
        if(data) {
          // here we try to parse out the access and id token from the api response
          try {
            const accessToken = data.AuthenticationResult.AccessToken
            const idToken = data.AuthenticationResult.IdToken

            if(accessToken) 
              this.accessToken = accessToken

            if(idToken) 
              this.idToken = idToken

            // save our session details here
            this.Save()
            
            res({
              refreshToken: token,
              accessToken: accessToken,
              idToken: idToken 
            })

          } catch(err) {
            rej(err)
          }
      }
      })
      
    }) 
  }

  /**
   * Returns the details for the currently auth'd user
   * @returns {Object} User details
   */
  currentAuthenticatedUser () {
    return new Promise(async (res, rej) => {
      try {
        res(jwt_decode(this.idToken))
      } 
  
      catch {
        rej(new Error("not logged in"))
      }
    })
  }


  currentSession () {
    return new Promise(async (res, rej) => {
      this.Read()

      if(!this.refreshToken) {
        rej(new Error("not logged in"))
      }
      
      try {
        // if we already have a full set of tokens we don't need to request any new ones just yet!
        let response = false
        if(this.idToken && this.accessToken && this.refreshToken) {
          response = {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            idToken: this.idToken 
          }
        } else {
          response = await this.Refresh()
        }
      
        response.User = await this.currentAuthenticatedUser()
        res(response)

      } catch {
        rej(new Error("not logged in"))
      }
    })
  }

  resetPassword (prevPW, newPW) {
    return new Promise(async (res, rej) => {
      try {
        let payload = {
          AccessToken: this.accessToken, /* required */
          PreviousPassword: prevPW, /* required */
          ProposedPassword: newPW /* required */ 
        };

        this.IdentifyProvider.changePassword(payload, function(err, data) {
          if (err) {
            rej(new Error('Failed to reset password.'));
          }
          else {
            if (data) {
              res(data);
            }
          }  
        });

      } 
      catch {
        rej(new Error('Failed to reset password.'))
      }
    })
  }

  SignOut () {
    return new Promise(async (res) => {
      // eslint-disable-next-line no-console
      console.log("sign out called")
      // eslint-disable-next-line no-console
      console.log(this.cookieName)
      // eslint-disable-next-line no-console
      console.log(this.cookieDomain)
      this.Clear()
      res(true)
    })
  }

  Save () {
    Cookies.set(this.cookieName, this.refreshToken, { expires: this.cookieDuration, path: '', domain: this.cookieDomain })
  }

  Read () {
    this.refreshToken = Cookies.get(this.cookieName) || false
  }

  Clear () {
    Cookies.remove(this.cookieName, { expires: this.cookieDuration, path: '', domain: this.cookieDomain })
  }
}


export default new Auth()